import { PropsWithChildren } from 'react';
import { css } from '../../../styled-system/css';
import { Flex } from '../../../styled-system/jsx';
import { labelFlyOut, labelFlyOutTerms } from '../../../styled-system/recipes';

export interface LabelFlyOutProps {
  details: string;
  label: string;
  onClick: () => void;
}

export const LabelFlyOut = ({
  children,
  details,
  label,
  onClick,
}: PropsWithChildren<LabelFlyOutProps>) => {
  return (
    <Flex className={labelFlyOut()} onClick={onClick}>
      {children}
      <dl className={labelFlyOutTerms()}>
        <dt className={css({ fontSize: 'lg', fontWeight: 'bold' })}>{label}</dt>
        <dd>{details}</dd>
      </dl>
    </Flex>
  );
};
